import { useEffect, useState } from "react";
import DramaCard from "@/components/feature/DramaCard";
import { dramas } from "@/mocks/dramas";
import { ratingRankIds } from "@/mocks/content";

const picks = ratingRankIds.slice(0, 8);

const dramaMap = new Map(dramas.map((d) => [d.id, d]));

export default function HighRatedSection() {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    setReady(true);
  }, []);

  const list = picks.map((id) => dramaMap.get(id)).filter(Boolean) as typeof dramas;

  return (
    <section id="rating" className="w-full bg-background-100 py-16 md:py-20">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-6">
        <div className="flex flex-col gap-5 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="font-label text-sm font-medium text-secondary-700">值得反复重刷</span>
            <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              高分剧单 · 评分稳定的口碑好剧
            </h2>
            <p className="mt-3 max-w-2xl font-body text-sm leading-relaxed text-foreground-600">
              这批剧集之所以留在榜单上，不是因为一时话题，而是因为它们经得起时间。家庭、治愈、悬疑、青春各有代表，适合作为你的“补剧清单”。
            </p>
          </div>
          <a
            href="#genres"
            className="inline-flex items-center gap-1.5 self-start whitespace-nowrap rounded-md border border-secondary-300 bg-background-50 px-4 py-2 font-label text-sm text-secondary-800 transition-colors hover:bg-secondary-100"
          >
            按题材继续筛选
            <i className="ri-arrow-right-line" aria-hidden="true"></i>
          </a>
        </div>

        {ready && (
          <div className="mt-8 grid grid-cols-2 gap-3 sm:grid-cols-3 md:gap-5 lg:grid-cols-4">
            {list.map((drama, index) => (
              <DramaCard key={drama.id} drama={drama} rank={index + 1} />
            ))}
          </div>
        )}
      </div>
    </section>
  );
}